"use strict";

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilePickerBuilder = getFilePickerBuilder;
exports.FilePickerBuilder = exports.FilePicker = exports.FilePickerType = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/// <reference types="@nextcloud/typings" />
var FilePickerType;
exports.FilePickerType = FilePickerType;

(function (FilePickerType) {
  FilePickerType[FilePickerType["Choose"] = 1] = "Choose";
  FilePickerType[FilePickerType["Move"] = 2] = "Move";
  FilePickerType[FilePickerType["Copy"] = 3] = "Copy";
  FilePickerType[FilePickerType["CopyMove"] = 4] = "CopyMove";
})(FilePickerType || (exports.FilePickerType = FilePickerType = {}));

var FilePicker = /*#__PURE__*/function () {
  function FilePicker(title, multiSelect, mimeTypeFilter, modal, type, directoriesAllowed, path) {
    _classCallCheck(this, FilePicker);

    this.title = title;
    this.multiSelect = multiSelect;
    this.mimeTypeFiler = mimeTypeFilter;
    this.modal = modal;
    this.type = type;
    this.directoriesAllowed = directoriesAllowed;
    this.path = path;
  }

  _createClass(FilePicker, [{
    key: "pick",
    value: function pick() {
      var _this = this;

      return new Promise(function (res, rej) {
        OC.dialogs.filepicker(_this.title, res, _this.multiSelect, _this.mimeTypeFiler, _this.modal, _this.type, _this.path, {
          allowDirectoryChooser: _this.directoriesAllowed
        });
      });
    }
  }]);

  return FilePicker;
}();

exports.FilePicker = FilePicker;

var FilePickerBuilder = /*#__PURE__*/function () {
  function FilePickerBuilder(title) {
    _classCallCheck(this, FilePickerBuilder);

    this.multiSelect = false;
    this.mimeTypeFiler = [];
    this.modal = true;
    this.type = FilePickerType.Choose;
    this.directoriesAllowed = false;
    this.title = title;
  }

  _createClass(FilePickerBuilder, [{
    key: "setMultiSelect",
    value: function setMultiSelect(ms) {
      this.multiSelect = ms;
      return this;
    }
  }, {
    key: "addMimeTypeFilter",
    value: function addMimeTypeFilter(filter) {
      this.mimeTypeFiler.push(filter);
      return this;
    }
  }, {
    key: "setMimeTypeFilter",
    value: function setMimeTypeFilter(filter) {
      this.mimeTypeFiler = filter;
      return this;
    }
  }, {
    key: "setModal",
    value: function setModal(modal) {
      this.modal = modal;
      return this;
    }
  }, {
    key: "setType",
    value: function setType(type) {
      this.type = type;
      return this;
    }
  }, {
    key: "allowDirectories",
    value: function allowDirectories() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.directoriesAllowed = allow;
      return this;
    }
  }, {
    key: "startAt",
    value: function startAt(path) {
      this.path = path;
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return new FilePicker(this.title, this.multiSelect, this.mimeTypeFiler, this.modal, this.type, this.directoriesAllowed, this.path);
    }
  }]);

  return FilePickerBuilder;
}();

exports.FilePickerBuilder = FilePickerBuilder;

function getFilePickerBuilder(title) {
  return new FilePickerBuilder(title);
}
//# sourceMappingURL=filepicker.js.map